import { useCallback } from 'react';
import t from 'utils/translate';
import { logger } from 'utils/logger';
import useError from 'hooks/useError';
import useSmartlook from 'hooks/useSmartlook';
import oAuthClient, { AuthError } from 'utils/auth/core';

export function useAuth() {
  const { showError } = useError();
  const { error } = useSmartlook();

  const loginWithKeycloakLink = useCallback(
    async (
      email: string,
      password: string,
      clientUUID: string,
      callbackUrl: string,
    ) => {
      try {
        logger.info('[useAuth][loginWithKeycloakLink] start', {
          clientUUID,
        });

        const json = await oAuthClient.login({
          email,
          password,
          clientUUID,
          callbackUrl,
        });

        logger.info('[useAuth][loginWithKeycloakLink] success');
        return json;
      } catch (err) {
        error('[useAuth][loginWithKeycloakLink]', err);
        logger.error(
          '[useAuth][loginWithKeycloakLink] failed',
          {
            clientUUID,
          },
          err as Error,
        );

        if (err instanceof AuthError) {
          if (err.error.type === 'no-access') {
            showError({
              message: t('unauthorized'),
              type: 'notification',
            });
          }
          if (err.error.type === 'unknown-error') {
            showError({
              message: t('generic'),
              type: 'notification',
            });
          }
        }
        return undefined;
      }
    },
    [showError, error, t],
  );

  return {
    loginWithKeycloakLink,
  };
}
